import qs from 'qs';

export function appendParams(url = '', params = {}) {
  let oParams;
  const searchIndex = url.indexOf('?');
  if (searchIndex === -1) {
    oParams = {};
  } else {
    oParams = qs.parse(url.slice(searchIndex + 1));
    // eslint-disable-next-line no-param-reassign
    url = url.slice(0, searchIndex);
  }

  return `${url}?${qs.stringify({
    ...oParams,
    ...params
  })}`;
}

/**
 * 获取url参数
 * @param  {string} name 参数名
 * @return {string} 参数值
 */
export function getUrlParam(name) {
  const url = window.location.search.split('#')[0];
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const res = url.substr(1).match(reg);
  if (res !== null) {
    return decodeURIComponent(res[2]);
  }
  return null;
}

/**
 * 将url中的querystring转换为object
 * @param  {String} url 如：a.com/b?c=d&e 或者 a=b&c=
 * @return {Object}     如：{c:'d',e:''}  或者 {a:'b',c:''}
 */
export function parseQuery(url = window.location.search, emptyValue = '') {
  let arr;
  if (url.includes('#')) {
    arr = url.split('#')[0].split('?');
  } else {
    arr = url.split('?');
  }
  const queryString = arr[arr.length - 1];
  const entrys = queryString === url ? [] : queryString.split('&');
  const res: Record<string, string> = {};
  for (let i = 0; i < entrys.length; i++) {
    const entry = entrys[i];
    const arr1 = entry.split('=');

    if (arr1[0]) {
      res[decodeURIComponent(arr1[0])] = decodeURIComponent(
        arr1[1] || emptyValue
      );
    }
  }

  return res as Record<string, string>;
}

/**
 * 获取path，保留key中对应的query参数
 * @param path
 * @param key
 * @returns
 */
export function getTargetUrl(path, key = 'from,inside') {
  const keys = key.split(',');
  const sources = keys.map(getUrlParam);
  let newPath = path;
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    const v = sources[i];
    // 避免反复调用时的重复添加
    if (v && newPath.indexOf(k) === -1) {
      if (newPath.includes('?')) {
        newPath = `${newPath}&${k}=${v}`;
      } else {
        newPath = `${newPath}?${k}=${v}`;
      }
    }
  }
  return newPath;
}

/**
 * 给当前页面 url 添加Query参数
 */
export function addQueryToCurrentHref(key: string, value: string) {
  const path = window.location.href;
  const oldValue = getUrlParam(key);
  if (key) {
    if (oldValue) {
      return path.replace(`${key}=${oldValue}`, `${key}=${value}`);
    }
    if (path.includes('?')) {
      return `${path}&${key}=${value}`;
    }
    return `${path}?${key}=${value}`;
  }
  return path;
}

/**
 * 转换带 query 的完整 url
 */
export function getCompletedUrlWithQuery(
  path = '/',
  query = {},
  targetOrigin?
) {
  const querys = {
    ...parseQuery(path),
    enableWK: 1,
    layoutType: 4,
    hyId: 'healthy-channel',
    ...query
  };
  const keys = Object.keys(querys);
  let s = '?';
  keys.forEach((key) => {
    if (
      querys[key] !== null &&
      querys[key] !== undefined &&
      querys[key] !== ''
    ) {
      s += `${key}=${querys[key]}&`;
    }
  });
  const queryString = s.slice(0, s.length - 1);
  const newPath = path.includes('?') ? path.split('?')?.[0] : path;
  return getTargetUrl(
    `${targetOrigin || window.location.origin}${newPath}${queryString}`
  );
}

/**
 * 获取三方跳转链接
 */
export function getThirdPartLoadUrl(url: string) {
  return `${window.location.origin}/med/outsite/${encodeURIComponent(url)}`;
}
